import axios from "axios";

/**
* Order and Shipment draft mixin only.
*/
export default {
  /**
  * If a component is meant to edit a draft must have the next properties.
  */
  data() {
    return {
      /** @responsability Stores the Draft object
      * in case that the current component its editing a draft
      */
      draft: null,
      draftName: null,
      processProperties: [
        'process',
        'processes',
        'nextResponsibility',
        'responsibilities',
        'processId',
        'tasks'
      ]
    }
  },
  /**
  * If a component is meant to edit a draft must have the next methods.
  */
  methods: {
    /**
    * This function takes the current Component.instance object
    * Stringify it and creates a Request a Draft instance of a Order to
    * be created in the server.
    * @async
    * @function
    * @returns {Promise<Object|null>} The draft instance returned from the server.
    */
    async saveAsDraft () {
      // Build the draft object.
      var draft = this.getDraft()
      try {
        // Set the loading as true to prevent double action clicking.
        this.loading = true
        // Create the draft request
        draft = (await axios.post('entity/graph', draft)).data
      } catch (e) {
        // TODO :  ASK FOR WAHT TO DO ON CASE OF ERROR
        console.error(e)
        draft = null
      } finally {
        this.loading = false
      }
      // The next function can be implemented to abstract what to do when a Draft is Created
      // right now does nothing.
      this.setViewAsDraft(draft)
      this.$router.push({name: 'draft.index'})
      return draft
    },

    /**
    * @responsability Create a new Draft Object instance or
    * return the current draft instance if the component its editing one.
    * @function
    * @returns {Object} A new Draft object or the Current Draft.
    */
    getDraft () {
      //Do a copy of the instance in order to save it to draft, set it with entityState = 4 to be ready to be saved
      let instanceCopy = {...this.instance};
      instanceCopy.entityState = 4;
      //About the instance(order or shipment) to be saved, delete id and uid in order to create a new one when save it
      delete instanceCopy.id;
      delete instanceCopy.uid;
      delete instanceCopy.externalId;
      delete instanceCopy.gNumber;
      delete instanceCopy.user;
      delete instanceCopy.comments;
      delete instanceCopy.files;
      delete instanceCopy.history;

      //delete all process related properties in each nested object in order to save the draft
      instanceCopy = this.deleteProperties(instanceCopy, this.processProperties);

      if (instanceCopy._Entity === 'Order' && instanceCopy.orderLines) {
        instanceCopy.orderLines.forEach(orderLine => {
          delete orderLine.id;
          delete orderLine.uid;
          delete orderLine.externalId;
          orderLine.entityState = 4;
          if (orderLine.product) {
            orderLine.product.entityState = 0;
          }
        });
      }
      else if (instanceCopy._Entity === 'Shipment' && instanceCopy.packages) {
        instanceCopy.packages.forEach(packg => {
          delete packg.id;
          delete packg.uid;
          delete packg.externalId;
          packg.entityState = 4;

          if (packg.packageContents) {
            packg.packageContents.forEach(pkContent => {
              delete pkContent.id;
              delete pkContent.uid;
              delete pkContent.externalId;
              pkContent.entityState = 4;
              if (pkContent.product) {
                pkContent.product.entityState = 0;
              }
              if (pkContent.orderLine) {
                pkContent.orderLine.entityState = 0;
              }
            });
          }
        });

        if (instanceCopy.shipmentContacts) {
          instanceCopy.shipmentContacts.forEach(sc => {
            delete sc.id;
            delete sc.uid;
            delete sc.externalId;
            sc.entityState = 4;
          });
        }

        //Update pacakges inside packageContents
        if (instanceCopy.packageContents != null && instanceCopy.packages != null) {
          instanceCopy.packageContents.forEach(pkgCnt => {
            instanceCopy.packages.forEach(pkg => {
              if(pkgCnt.package.uid == pkg.uid){
                pkgCnt.package = pkg;
              }
            });  
          });
        }
      }

      return {
        _Entity: 'Draft',
        // If the component its already editing a draft
        // set the current draft as edited (EntityState = 3).
        entityState: this.isDraft ? 3 : 4,
        // Use the entityName to create the correct draft type.
        entity: this.entityName,
        name: this.draftName,
        // If the component its already editing a draft must
        // take the id to edit the current draft
        id: this.draft ? this.draft.id : 0,
        // Stringify the current instance data.
        content: JSON.stringify(instanceCopy)
      }
    },
    /**
    * @responsability This function is responsable for doing all the things that need to be done
    * after a draft creation like:  takes a Draft and sets the view
    * and populates the data with the Draft.content.
    * The next function can be implemented to abstract what to do when a Draft is Created
    * right now does nothing.
    * @function
    * @returns {undefinded}
    */
    setViewAsDraft(draft) {
      // this.isDraft = true
      // this.instance = JSON.parse(draft)
    },
    /**
    * @responsability Load the draft instance from the server
    * @function
    * @async
    * @returns {Promise<Object|null>} The draft instance or a null if doesnt exists.
    */
    async loadDraft() {
      // if the draft does not exit return
      if (!this.isDraft) return null
      try {
        this.draft = (await axios.get(`drafts/${this.$route.params.item}`)).data
        let _draft = JSON.parse(this.draft.content)
        _draft.uid = this.$generateUid();

        this.loading = false
        this.draftName = this.draft && this.draft.name

        _draft = {
          partyFrom: {contactParties:[]},
          partyTo: {contactParties:[]},
          ..._draft,
        };

        this.instance = {..._draft};
        const { status } = this.instance;
        ({ blockEdit: this.blockEdit } = status || {});


        return this.draft
      } catch (e) {
        console.error(e)
        return null
      }
    },
    deleteProperties(instance, propertiesToDelete) {
      Object.entries(instance).forEach(([ key, value ]) => {
        if (propertiesToDelete.includes(key)) {
          delete instance[key];
          return false;
        }
        if (value && typeof(value) === 'object') {
          this.deleteProperties(value, propertiesToDelete);
        }
      });
      return instance;
    }

  },
  /**
  * If a component is meant to edit a draft must have the next computed values.
  */
  computed: {
    /**
    * @responsability Say if a component is editing a Draft instead of the real Entity instance.
    * @function
    * @name isDraft.
    * @returns {bool} True if the component is editing a draft
    */
    isDraft() {
      // The current approach its to use the current route name
      // to define if the component its editing a draft.
      return this.$route.name.endsWith('draft')
    }
  }
}
